module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "meeting-content"
  }, [_c('h3', [_vm._v("全国糖酒商品交易会 — 展会信息")]), _vm._v(" "), _c('div', {
    staticClass: "meeting-info"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.headerinfo.zhuban))]), _vm._v(" "), (_vm.chenbanArr) ? _c('div', [_vm._m(1), _vm._v(" "), _vm._l((_vm.chenbanArr), function(name) {
    return _c('p', {
      key: _vm.chenbanArr.id
    }, [_vm._v(_vm._s(_vm.delSpace(name)))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.xiebanArr) ? _c('div', [_vm._m(2), _vm._v(" "), _vm._l((_vm.xiebanArr), function(name) {
    return _c('p', {
      key: _vm.xiebanArr.id
    }, [_vm._v(_vm._s(_vm.delSpace(name)))])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "header-info"
  }, [_c('span', [_vm._v("布展时间：" + _vm._s(_vm.headerinfo.readytime))]), _c('i', [_vm._v("/")]), _vm._v(" "), _c('span', [_vm._v("开展时间：" + _vm._s(_vm.headerinfo.starttime))]), _c('i', [_vm._v("/")]), _vm._v(" "), _c('span', [_vm._v("展会地址：" + _vm._s(_vm.headerinfo.addr))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "small-title"
  }, [_c('i', {
    staticClass: "icon-circle"
  }), _vm._v("主办方")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "small-title"
  }, [_c('i', {
    staticClass: "icon-circle"
  }), _vm._v("承办方")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "small-title"
  }, [_c('i', {
    staticClass: "icon-circle"
  }), _vm._v("协办方")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-704195f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/MeetingInfo.vue
// module id = 180
// module chunks = 1